module.exports = __webpack_public_path__ + "img/dj_snake.7b1ff66f.jpg";